module.exports = __webpack_public_path__ + "images/home/product/mobile/features-repository-f1fefa174072b16f45d472237b61e1c2.png";